import {ReactNode} from "react";

export type NewEntityModalType = {
    title: string;
    text?: string;
    children: ReactNode;
    onClose?: () => void;
};
export default function ModalLayout({
                                        children,
                                        title,
                                        text,
                                    }: // onClose,
                                        NewEntityModalType) {
    return (
        <>
            <div className={"modal-wrapper"}>
                <div className="add-modal-entity">
                    <div className={"add-entity-text"}>
                        <h6 style={{fontSize: "19px", fontWeight: "bold", color: "black"}}>{title}</h6>
                        <p className="paragraph-2">{text}</p>
                    </div>
                    {children}
                </div>
            </div>
        </>
    );
}
